import React from 'react'
import { useTranslation } from 'react-i18next'
import './Button.css'
const Button = (props) => {
    const { t } = useTranslation()

    return (
        <button
            className={`button ${props.classes ? props.classes : ' '}`}
            onClick={props.onClick}
            style={props.style}
            disabled={props.disabled}
        >
            {props.name}
        </button>
    )
}

export default Button
